<template>
  <div class="document-dialog" v-if="showMessageBox">
    <el-dialog
      :visible.sync="showMessageBox"
      top="30vh"
      :center="false"
      width="370px"
      style="border-radius:15px;z-index: 2001"
      :close-on-click-modal="false"
      :before-close="close"
    >
      <div slot="title" class="dialog-title ml5 left">提示信息</div>
      <div class="login-tip">
        <img src="../../assets/image/prompt/wycExample.png" />
      </div>
      <div class="login-tip">
        <div class="showMsg">
          <strong
            >经过该功能处理后将清理所有样式，仅保留文本。请在文章加入样式前使用</strong
          >
        </div>
      </div>
      <div slot="footer" class="dialog-footer ml5 left">
        <span style="font-size: 12px;color: #666"
          ><el-checkbox v-model="showCheck.isCheck"></el-checkbox
          >以后不再出现</span
        >
        <el-button size="mini" class="agree" @click="toCheck(true)"
          >继续使用</el-button
        >
        <el-button size="mini" class="cancel" @click="toCheck(false)"
          >放弃使用</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "wycShowBox",
  data() {
    return {
      showCheck: {
        isCheck: false,
        checkType: false
      }
    };
  },
  props: {
    showMessageBox: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapMutations("contents", ["setWycShowMsg"]),
    ...mapMutations("wycContent", ["setopenWycNum"]),
    toCheck(type) {
      this.showCheck.checkType = type;
      localStorage.setItem("wycShowTip", JSON.stringify(this.showCheck));
      this.setopenWycNum(1);
      this.showCheck.isCheck = false;
      this.close();
    },
    close() {
      this.setWycShowMsg(false);
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/mixin";
.document-dialog {
  .login-tip {
    text-align: center;
    margin: 10px 0;
    line-height: 22px;
    font-size: 12px;
    .showMsg {
      background-color: #fff0e4;
      color: #ef7428;
      font-size: 12px;
      padding: 5px 28px;
      border-radius: 5px;
    }
    .msgTitle {
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 20px;
    }
    img {
      margin-top: 10px;
    }
  }
  .dialog-tologin {
    border-radius: 20px;
    padding: 7px 15px !important;
  }
  .agree {
    .dialog-tologin();
    .btn();
    margin-right: 0 !important;
    margin-left: 10px;
  }
  .cancel {
    .dialog-tologin();
    .gbtn();
  }
  .dialog-document .dialog-title {
    font-size: 14px;
  }
  /deep/.el-dialog__header {
    border-bottom: 1px solid #e2e3e5;
    padding: 15px 20px 15px;
  }
  /deep/.el-dialog {
    border-radius: 4px;
  }
  /deep/.el-dialog__body {
    padding: 0 20px 0 20px;
  }
}
</style>
